import React from 'react'
import style from './style.module.less'
export default ({ children }) => (
  <div className={style.shadowBox}>{children}</div>
)
